import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: 'https://sso.monitapp.io',
    realm: 'mon',
    clientId: 'platform-ops',
});

export default keycloak;
